import { render, staticRenderFns } from "./RecordsList.vue?vue&type=template&id=2d1663d8&"
import script from "./RecordsList.vue?vue&type=script&lang=ts&"
export * from "./RecordsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports